import api from "../api/axiosInstance";

// ✅ Fetch all success stories
export const fetchSuccessStories = async () => {
  try {
    const response = await api.get("/success-stories/all");
    return response.data;
  } catch (error) {
    console.error("Error fetching success stories:", error);
    throw error;
  }
};

// ✅ Create a new success story
export const createSuccessStory = async (storyData) => {
  try {
    const formData = new FormData();
console.log('service:',storyData);

    formData.append("coupleName", storyData.coupleName);
    formData.append("description", storyData.description);
    formData.append("image", storyData.image); // ✅ file
    const response = await api.post("/success-stories/create", formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // ✅ override
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating success story:", error);
    throw error;
  }
};

// ✅ Get a success story by ID
export const getSuccessStoryById = async (id) => {
  try {
    const response = await api.get(`/success-stories/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching success story by ID:", error);
    throw error;
  }
};

// ✅ Update an existing success story
export const updateSuccessStory = async (storyData) => {
  try {
    console.log("Update Success Story ID:", storyData._id);
    
    console.log("Updating success story:", storyData);
    
    const formData = new FormData();

    formData.append("coupleName", storyData.coupleName);
    formData.append("description", storyData.description);
     // ✅ ONLY append image if it's a new file
    if (storyData.image instanceof File) {
      formData.append("image", storyData.image);
    }
    const response = await api.put(`/success-stories/${storyData._id}`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // ✅ override
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating success story:", error);
    throw error;
  }
};

// ✅ Delete a success story
export const deleteSuccessStory = async (id) => {
  try {
    await api.delete(`/success-stories/${id}`);
  } catch (error) {
    console.error("Error deleting success story:", error);
    throw error;
  }
};
